import { GetAllSearchTaskEvent, GetAllSearchTaskResult } from 'bloggers-backend/lib/youtube/domain/events';
import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Grid, { QueryOptions } from './Grid';
import { AppContext } from '../AppContext';
import { FormatUserTime, useUserTime } from '../hooks/useUserTime';


const buildColumns = (formatUserTime: FormatUserTime): GridColDef[] => [
  {
    field: 'query',
    headerName: 'query',
    filterable: true,
    sortable: true,
    renderCell: ({row}: any) => (<Link to={`/search-tasks/${row?.id}`}>{row?.query}</Link>)
  },
  { field: 'createdAt', headerName: 'created at', width: 300, filterable: true, sortable: true, valueGetter: (_value, row) => formatUserTime(row?.createdAt)},
  { field: 'status', headerName: 'status', width: 150, filterable: true, sortable: true },
  { field: 'completed', headerName: 'completed', width: 150, filterable: true, sortable: true, type: 'boolean'},
  { field: 'manager.name', headerName: 'manager', width: 150, filterable: true, sortable: true, valueGetter: (_value, row) => row?.manager?.name},
];


export default function SearchTasksPage() {
  const {notificationsService, client} = React.useContext(AppContext)
  const navigate = useNavigate();
  const formatUserTime = useUserTime();
  const columns = React.useMemo(() => buildColumns(formatUserTime), [formatUserTime]);

  const fetchData = async (options: QueryOptions) => {
    const result = await client<GetAllSearchTaskEvent, GetAllSearchTaskResult>({
      event: 'getAllSearchTasks',
      data: options as any
    })

    if (result.success) {
      return result.value
    } else {
      notificationsService.notify({
        severity: 'error',
        message: `Error: ${JSON.stringify(result.errors)}`
      });

      return {data: [], pageInfo: {}}
    }
  };

  return <Box sx={{display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{marginBottom: 1}}>
      <Button
        variant="contained"
        onClick={() => navigate('/search-tasks/new')}
      >
        Create new search task
      </Button>
    </Box>
    <Box sx={{flexGrow: 1}}>
      <Grid
        columns={columns}
        cacheName={'search-tasks'}
        fetchData={fetchData}
        onRowClick={(id) => {}}
      />
    </Box>
  </Box>
}
